import { render, staticRenderFns } from "./integral_category_edit.vue?vue&type=template&id=b4e8c6c8&scoped=true"
import script from "./integral_category_edit.vue?vue&type=script&lang=ts"
export * from "./integral_category_edit.vue?vue&type=script&lang=ts"
import style0 from "./integral_category_edit.vue?vue&type=style&index=0&id=b4e8c6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e8c6c8",
  null
  
)

export default component.exports